// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"379":"72e45963","703":"7f7f4345"}[chunkId] + ".chunk.js";
};